import EventsEmpty from './EventsEmpty';

export default EventsEmpty;
